import type { UUID } from '@cobliteam/common-types';
import type { WebhooksCustomHeader } from './WebhookTypes';

export type DebounceMode = 'DEBOUNCE' | 'COUNT_WINDOW';

export interface DebounceDefault {
  eventType: string;
  debounceMode: DebounceMode;
  debounceMs: number;
  minCount?: number;
}

export interface DebounceConfig {
  eventType: string;
  debounceMode: DebounceMode;
  debounceMs: number;
  minCount?: number;
}

export type DebounceConfigMap = Record<string, DebounceConfig>;

/** iris ADR-0006: `error` value returned when the customer upstream is unreachable. */
export const WEBHOOK_TEST_UPSTREAM_UNREACHABLE = 'upstream_unreachable';

/**
 * iris ADR-0006: body returned by POST /public/v1/signatures/test on newer
 * iris versions. Older iris versions answer with a plain string body and
 * mirror the upstream status code instead.
 */
export interface WebhookTestResponseBody {
  success: boolean;
  error?: string;
  upstream_status?: number | null;
  upstream_body?: string;
}

export interface WebhooksAddContent {
  id?: UUID;
  name: string;
  url: string;
  eventTypes: string[];
  secretKey: string;
  customHeaders: WebhooksCustomHeader;
  createdAt?: string;
  updatedAt?: string;
}

export interface WebhooksUpdateContent {
  id: UUID;
  name: string;
  url: string;
  eventTypes: string[];
  secretKey: string;
  customHeaders: WebhooksCustomHeader;
  createdAt?: string;
  updatedAt?: string;
  active?: boolean;
  failureStartedAt?: string | null;
  failureAttempts?: number | null;
  failureReason?: string | null;
  deactivatedAt?: string | null;
}
